import { moveToFulfilled } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { GroupSidebarLoadFulfilledAction } from '../../domains/groupSidebarLoad/actions.types';

import type { GroupCampaignPermissions } from './types';

export type GroupCampaignPermissionActions = GroupSidebarLoadFulfilledAction;

const initialState: GroupCampaignPermissions = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<GroupCampaignPermissions, GroupCampaignPermissionActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_SIDEBAR.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupCampaignPermissions);
    default:
      return state;
  }
};

export default reducer;
